import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { dataFakeForLoading } from '../Utils/Constants/Product';

interface LayoutType {
  mainLoading: boolean;
  setMainLoading: CallableFunction;
  mainLoadingIcon: boolean;
  setMainLoadingIcon: CallableFunction;
  mainLoadingIconInfo: boolean;
  setMainLoadingIconInfo: CallableFunction;
  mainLoadingIconSuccess: boolean;
  setMainLoadingIconSuccess: CallableFunction;
  mainLoadingIconError: boolean;
  setMainLoadingIconError: CallableFunction;
  mainLoadingIconSearch: boolean;
  setMainLoadingIconSearch: CallableFunction;
  mainLoadingIconNoSearchMap: boolean;
  setMainLoadingIconNoSearchMap: CallableFunction;
  mainLoadingIconMapCheck: boolean;
  setMainLoadingIconMapCheck: CallableFunction;
  mainLoadingTitle: string;
  setMainLoadingTitle: CallableFunction;
  mainLoadingMessage: string;
  setMainLoadingMessage: CallableFunction;
  mainLoadingCloseButton: boolean;
  setMainLoadingCloseButton: CallableFunction;
  mainLoadingLabelCloseButton: string;
  setMainLoadingLabelCloseButton: CallableFunction;
  mainLoadingIconErrorAddProduct: boolean;
  setMainLoadingIconErrorAddProduct: CallableFunction;
  mainLoadingIconSearchCart: boolean;
  setMainLoadingIconSearchCart: CallableFunction;
  mainLoadingAutoClose: boolean;
  setMainLoadingAutoClose: CallableFunction;
  isMobile: boolean;
  isOnline: boolean;
  setIsOnline: CallableFunction;
  hasError: boolean;
  setHasError: CallableFunction;
  productsToSearch: any;
  setProductsToSearch: CallableFunction;
  categories: any;
  setCategories: CallableFunction;
  initialViewMode: string;
  viewMode: string;
  setViewMode: (value: string) => void;
  forceViewModeSwiperImage: boolean; 
  setForceViewModeSwiperImage: (value: boolean) => void;
  welcomeScreenRead: boolean;
  setWelcomeScreenRead: (value: boolean) => void;
  isGeolocationAllowed: boolean;
  setIsGeolocationAllowed: (value: boolean) => void;
  isCategoriesSwiperViewed: boolean;
  setIsCategoriesSwiperViewed: (value: boolean) => void;
  company: any;
  setCompany: CallableFunction;
  companyPages: any;
  setCompanyPages: CallableFunction;
  versionFront: any;
  setVersionFront: CallableFunction;
  states: any;
  setStates: CallableFunction;
}

const LayoutContext = createContext<LayoutType | undefined>(undefined);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {

  const [mainLoading, setMainLoading] = useState(false);
  const [mainLoadingIcon, setMainLoadingIcon] = useState(true);
  const [mainLoadingIconInfo, setMainLoadingIconInfo] = useState(false);
  const [mainLoadingIconSuccess, setMainLoadingIconSuccess] = useState(false);
  const [mainLoadingIconError, setMainLoadingIconError] = useState(false);
  const [mainLoadingIconSearch, setMainLoadingIconSearch] = useState(false);
  const [mainLoadingIconSearchCart, setMainLoadingIconSearchCart] = useState(false);
  const [mainLoadingIconNoSearchMap, setMainLoadingIconNoSearchMap] = useState(false);
  const [mainLoadingIconMapCheck, setMainLoadingIconMapCheck] = useState(false);
  const [mainLoadingTitle, setMainLoadingTitle] = useState('Aguarde...');
  const [mainLoadingMessage, setMainLoadingMessage] = useState('');
  const [mainLoadingCloseButton, setMainLoadingCloseButton] = useState(false);
  const [mainLoadingLabelCloseButton, setMainLoadingLabelCloseButton] = useState('Ok, entendi');
  const [mainLoadingIconErrorAddProduct, setMainLoadingIconErrorAddProduct] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const initialViewMode = 'swiper';
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('view_mode') || initialViewMode)
  const [forceViewModeSwiperImage, setForceViewModeSwiperImage] = useState(true)
  const [company, setCompany] = useState(null)
  const [companyPages, setCompanyPages] = useState(null)
  const [states, setStates] = useState<any[]>([]);
  const [versionFront, setVersionFront] = useState(() => localStorage.getItem('version') || null)
  const [productsToSearch, setProductsToSearch] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>(dataFakeForLoading);
  const [welcomeScreenRead, setWelcomeScreenRead] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('welcome_read');
    return storedValue === 'true';
  });
  const [isCategoriesSwiperViewed, setIsCategoriesSwiperViewed] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('categories_swiper_viewed');
    return storedValue === 'true';
  });
  const [isGeolocationAllowed, setIsGeolocationAllowed] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('geolocation_allowed');
    return storedValue === 'true';
  });
  const [mainLoadingAutoClose, setMainLoadingAutoClose] = useState(false);

  useEffect(() => {
    localStorage.setItem('geolocation_allowed', String(isGeolocationAllowed))
  }, [isGeolocationAllowed])

  useEffect(() => {
    localStorage.setItem('view_mode', viewMode)
  }, [viewMode])

  useEffect(() => {
    if (versionFront) {
      localStorage.setItem('version', versionFront)
    } else {
      localStorage.removeItem('version')
    }
  }, [versionFront])

  useEffect(() => {
    localStorage.setItem('welcome_read', welcomeScreenRead.toString());
  }, [welcomeScreenRead]);

  useEffect(() => {
    localStorage.setItem('categories_swiper_viewed', isCategoriesSwiperViewed.toString());
  }, [isCategoriesSwiperViewed]);

  useEffect(() => {
    if (mainLoading === false) {
      setTimeout(() => { //* timeout only for layout
        setMainLoadingIcon(true);
        setMainLoadingIconInfo(false);
        setMainLoadingIconSuccess(false);
        setMainLoadingIconError(false);
        setMainLoadingIconSearch(false);
        setMainLoadingIconNoSearchMap(false);
        setMainLoadingIconMapCheck(false);
        setMainLoadingTitle('');
        setMainLoadingMessage('');
        setMainLoadingLabelCloseButton('Ok, entendi');
        setMainLoadingCloseButton(false);
        setMainLoadingIconErrorAddProduct(false);
        setHasError(false);
        setMainLoadingIconSearchCart(false);
        setMainLoadingAutoClose(false);
      }, 250);
    }
  }, [mainLoading])

  useEffect(() => {
    window.addEventListener('resize', () => {
        setIsMobile(window.innerWidth < 768)
    })
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };

  }, [])

  useEffect(() => {
    if (isMobile) {
      setViewMode(initialViewMode);
    } else {
      setViewMode('list');
    }

    setForceViewModeSwiperImage(isMobile);
  }, [isMobile])

  return (
    <LayoutContext.Provider value={{
        mainLoading, setMainLoading,
        mainLoadingIcon, setMainLoadingIcon,
        mainLoadingIconInfo, setMainLoadingIconInfo,
        mainLoadingIconSuccess, setMainLoadingIconSuccess,
        mainLoadingIconError, setMainLoadingIconError,
        mainLoadingIconSearch, setMainLoadingIconSearch,
        mainLoadingIconNoSearchMap, setMainLoadingIconNoSearchMap,
        mainLoadingIconMapCheck, setMainLoadingIconMapCheck,
        mainLoadingTitle, setMainLoadingTitle,
        mainLoadingMessage, setMainLoadingMessage,
        mainLoadingCloseButton, setMainLoadingCloseButton,
        mainLoadingIconErrorAddProduct, setMainLoadingIconErrorAddProduct,
        mainLoadingIconSearchCart, setMainLoadingIconSearchCart,
        mainLoadingLabelCloseButton, setMainLoadingLabelCloseButton,
        mainLoadingAutoClose, setMainLoadingAutoClose,
        isMobile,
        initialViewMode,
        viewMode, setViewMode,
        forceViewModeSwiperImage, setForceViewModeSwiperImage,
        isOnline, setIsOnline,
        hasError, setHasError,
        productsToSearch, setProductsToSearch,
        categories, setCategories,
        welcomeScreenRead, setWelcomeScreenRead,
        isGeolocationAllowed, setIsGeolocationAllowed,
        isCategoriesSwiperViewed, setIsCategoriesSwiperViewed,
        company, setCompany,
        companyPages, setCompanyPages,
        versionFront, setVersionFront,
        states, setStates
      }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
